import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "../Reducers";
import { thunk } from "redux-thunk";
import { cookiesMiddleware } from "../Middlewares/cookiesMiddleware";
import { promiseMiddleware } from "../Middlewares/promiseMiddleware";
import { loggingMiddleware } from "../Middlewares/loggingMiddleware";
import createOidcMiddleware from "redux-oidc";

const dummyMiddleware = () => (next) => (action) => {
  return next(action);
};

export default function configureStore(initialState, userManager) {
  const state = { cookies: initialState, oidc: { user: "" } };

  const oidcMiddleware = !userManager.error
    ? createOidcMiddleware(userManager, () => true, false, "/callback")
    : dummyMiddleware;

  const store = createStore(
    rootReducer(),
    state,
    compose(
      applyMiddleware(
        thunk,
        //apolloClient.middleware(),
        cookiesMiddleware,
        promiseMiddleware,
        oidcMiddleware,
        loggingMiddleware
      ),
      window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : (f) => f
    ) //Redux dev tools
  );

  return store;
}
